import template from './TheSidebar.html';

export default {
	template,
	props: ['custom-scroll'],
	data() {
		return {
			scrollTop: 0
		};
	},
	computed: {
		shouldShowContent() {
			return (this.app.user !== undefined);
		},
		pages() {
			let pages = [
				{url: '/dashboard', text: 'Dashboard', icon: 'dashboard', searchParams: true},
				//{url: '/heatmap', text: 'Heatmap', icon: 'heatmap', searchParams: true},
				//{url: '/video', text: 'Video', icon: 'video'},
				{
					text: 'Statistics',
					icon: 'stats',
					alwaysOpen: true,
					children: [
						{url: '/stat', text: 'Website statistics', icon: 'bar-chart', searchParams: true},
						{url: '/stat/domains', text: 'Domains', icon: 'globe', searchParams: true},
						{url: '/stat/subdomains', text: 'Subdomains', icon: 'sitemap', searchParams: true},
						{url: '/stat/pages', text: 'Pages', icon: 'page', searchParams: true},
						{url: '/stat/countries', text: 'Countries', icon: 'flag', searchParams: true},
						{url: '/stat/languages', text: 'Languages', icon: 'language', searchParams: true},
						{url: '/stat/timezones', text: 'Timezones', icon: 'clock-o', searchParams: true},
						{url: '/stat/isps', text: 'ISPs', searchParams: true, hidden: !this.checkFeature('isp')},
						{url: '/stat/sources', text: 'Sources', icon: 'mail-reply-all', searchParams: true},
						{url: '/stat/referrers', text: 'Referrer domains', icon: 'reply', searchParams: true},
						{url: '/stat/referrer-pages', text: 'Referrer pages', icon: 'reply', searchParams: true},
						{url: '/stat/phrases', text: 'Search phrases', icon: 'search', searchParams: true},
						//{url: 'stat/users', text: 'Users', icon: 'users', searchParams: true},
						//{url: 'stat/cookies', text: 'Cookies', icon: 'user-plus', searchParams: true},
						//{url: 'stat/ips', text: 'IPs', icon: 'map-marker', searchParams: true},
						{url: '/stat/screens', text: 'Screens', icon: 'screen', searchParams: true},
						{url: '/stat/os', text: 'OS', icon: 'os', searchParams: true},
						{url: '/stat/browsers', text: 'Browsers', icon: 'browser', searchParams: true},
						{url: '/stat/vendors', text: 'Vendors', icon: 'wrench', searchParams: true},
						{url: '/stat/devices', text: 'Devices', icon: 'device', searchParams: true},
					]
				},
				{
					text: 'Activity',
					icon: 'activity',
					children: [
						{url: '/sessions', text: 'Sessions', icon: 'history', searchParams: true},
						{url: '/pageviews', text: 'PageViews', icon: 'eye', searchParams: true}
					]
				},
				{},
				{url: '/domains', text: 'My domains', icon: 'domains', hidden: !this.app.idu},
				{url: '/counter', text: 'My counter', icon: 'counter', hidden: !this.app.idu},
				{url: '/integrations', text: 'Integrations', icon: 'plus', hidden: !this.app.idu},
				{url: '/settings', text: 'Settings', icon: 'settings', hidden: !this.app.idu, isPrefixPath: true}
			];

			pages.forEach(page => {
				if (page.children) {
					page.childrenVisible = page.alwaysOpen || !!page.children.find(item => this.checkCurrent(item));
				}
			});

			return pages;
		}
	},
	methods: {
		checkCurrent(item) {
			if (!item.url) return false;

			let curUrl = this.$route.path;
			let itemUrl = item.url.replace(/\?.*/, '');
			return curUrl === itemUrl;
		},
		toggleChildren(item) {
			item.childrenVisible = !item.childrenVisible;
			this.$forceUpdate();
		},
		getItemUrl(item) {
			if (!item.searchParams) return item.url;

			let routes = ['dashboard', 'slices', 'summary', 'pageviews', 'sessions', 'heatmap'];
			let withQuery = (routes.indexOf(this.$route.name) !== -1);

			let query = {};
			if (withQuery) {
				query = {...this.app.query};
				delete query.screenDeviation;
				if (query.page === '/*') {
					delete query.page;
				}
			}

			if (item.url === '/dashboard') {
				delete query.dates;
			}
			return item.url + '?' + this.url.queryToString(query);
		},
		onScroll(e) {
			if (!this.customScroll) return;

			e.preventDefault();

			let inc = 20 * (e.deltaY > 0 ? -1 : 1);

			this.scrollTop += inc;
			if (this.scrollTop > 0) {
				this.scrollTop = 0;
			}

			let sidebar = this.$refs.sidebar;

			let extra = window.innerHeight - this.$el.offsetTop - sidebar.scrollHeight - this.scrollTop;
			if (extra > 0) {
				this.scrollTop += extra;
			}
		}
	}
}